<!--列表查看视图-->
<template>
  <div class="details-view">
    <cargo-left-right-resize
      :left-style="{flex:'none','max-width':'190px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template slot="left">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          class="section"
          style="min-width: 160px;width:100%;height:100%;"
          :check-sub-record="false"
          :check-main-record="false"
          :deselect-main-record="false"
          :deselect-sub-record="false"
          @gridReady="params=>{gridApi=params.api}"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 10px">
            <div class="filters">
              <!-- todo -->
            </div>
            <div class="triggers">
              <cargo-button-group-slider>
                <c-a-btn-group source-view="detail" :job="job" :hp="cADetailHp" style="flex-wrap:wrap;" :active-tab-name="activeTabName" />
              </cargo-button-group-slider>
              <div style="white-space: nowrap;">
                <label class="red" style="font-weight: bold;font-size: 15px;height: 25px;">{{ jobState }}</label>
                <label class="red" style="font-weight: bold;font-size: 15px;height: 25px;">{{ jobChangeState }}</label>
                <!--todo 天眼查-->
                <label>{{ '' }}</label>
                <label class="blue" style="height: 25px;">{{ job.jobNo }}</label>
                <label class="blue" style="height: 25px;">{{ $store.getters.language === 'zh' ? customerChineseName : customerEnglishName }}</label>
              </div>
            </div>
          </div>
          <div class="tabs-container">
            <el-tabs v-model="activeTabName" type="card" style="width: 100%" @tab-click="handleTabClick">
              <el-tab-pane :key="10" :lazy="true" :label="$t('CargoMsg.Cargo_Basic')" name="basic">
                <basic ref="basic" :lob="lob" :master-flag="masterFlag" :se-context="seContext" :job="job" />
              </el-tab-pane>
              <el-tab-pane v-if="lob==='SE'" :key="20" :lazy="true" name="tabVesselEq" :label="$t('CargoMsg.Cargo_Booking')">
                <tab-vessel-eq ref="tabVesselEq" :context="seContext" :action="action" />
              </el-tab-pane>
              <el-tab-pane :key="21" :lazy="true" name="tabCharges" :label="$t('CargoMsg.Cargo_Cost')">
                <tab-charges ref="tabCharges" :context="seContext" :action="action" :adjust="adjust" :location="location" is-from-finance />
              </el-tab-pane>
              <el-tab-pane :key="22" :lazy="true" name="tabInternalBill" :label="$t('CargoMsg.Cargo_DomesticBill')">
                <tab-internal-bill ref="tabInternalBill" :context="seContext" :action="action" :location="location" />
              </el-tab-pane>
              <el-tab-pane :key="23" :lazy="true" name="tabOverseaBill" :label="$t('CargoMsg.Cargo_InternationalBill')">
                <tab-oversea-bill ref="tabOverseaBill" :context="seContext" :action="action" :location="location" />
              </el-tab-pane>
              <el-tab-pane :key="24" :lazy="true" name="tabAdvanceCharge" :label="$t('CargoMsg.Cargo_AdvanceChargeInfo')">
                <tab-advance-charge ref="tabAdvanceCharge" :context="seContext" :action="action" :adjust="adjust" :location="location" />
              </el-tab-pane>
              <el-tab-pane v-if="showTabSopState" :key="29" :lazy="true" name="tabSopState" :label="$t('CargoMsg.Cargo_BusinessStatus')">
                <tab-sop-state ref="tabSopState" :context="seContext" :action="action" is-from-finance />
              </el-tab-pane>
              <el-tab-pane :key="28" :lazy="true" name="tabFileHistory" :label="$t('CargoMsg.Cargo_FileHistory')">
                <tab-file-history ref="tabFileHistory" :context="seContext" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </div>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import {} from '@/api/clearing/financeManage'
import { BookingWorkspaceContext } from '@/views/cargo/v0/SeaExport/components/booking/bookingWorkspaceContext'
// components
import cABtnGroup from './cABtnGroup'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import basicTab from './cABasicTab'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'

import tabVesselEq from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabVesselEq'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import tabInternalBill from '@/components/Cargo/Job/booking/tabs/tabInternalBill'
import tabOverseaBill from '@/components/Cargo/Job/booking/tabs/tabOverseaBill'
import tabAdvanceCharge from '@/components/Cargo/Job/booking/tabs/tabAdvanceCharge'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState'
import ColumnUtils from '@/utils/ColumnUtils'
import { Company } from '@/class/model/mdm/Company'
import { calculateProfit } from '@/api/seaExport/seaExportJob'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import CADetailHp from '@/views/cargo/v0/Clearing/components/ClosingAccount/cADetailHp'
import { LOG_CARRY_FORWARD } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'ClosingAccountDetail',
  components: {
    CargoButtonGroupSlider,
    cABtnGroup,
    cargoAdvanceSelect,
    tabVesselEq,
    tabCharges,
    tabInternalBill,
    tabOverseaBill,
    tabAdvanceCharge,
    tabFileHistory,
    tabSopState,
    basic: basicTab,
    cargoTemplateSelectorDialog,
    cargoLeftRightResize
  },
  props: {
    viewSource: { type: String, required: true }
  },
  data() {
    return {
      job: {},
      showContentArea: false,
      loading: false,
      isCommittedAllowAddCost: false,
      cADetailHp: new CADetailHp(this),
      seContext: new BookingWorkspaceContext(),
      jobUuid: '',
      bookingAction: '',
      activeTabName: 'basic',
      lob: '',
      adjust: true, // 代收垫付页签专用 控制提交/取消提交按钮是否显示
      action: 'look', // 财务审核默认查看状态
      masterFlag: false,
      tabsRenderedSet: new Set(), // 已经渲染操作过的tabs
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new SeaExportJob(),
        category: 'JOBLIST',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        }
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        likeName: '' // 模糊查询名称
      },
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      rowData: [],
      jobState: '', // 业务状态
      jobChangeState: '', // 改单状态
      customerChineseName: '', // 客户中文名
      customerEnglishName: '' // 客户英文名
    }
  },
  computed: {
    showTabSopState() {
      return (['SI', 'AE', 'AI'].includes(this.lob) && !this.masterFlag) || ['RE', 'RI', 'SE'].includes(this.lob)
    },
    location() {
      if (!this.job.fba) {
        return LOG_CARRY_FORWARD.code
      }
      return ''
    }
  },
  watch: {
  },
  created() {
    this.cADetailHp.created()
    this.seContext.prepareData()
  },
  methods: {
    // 初始化右上角业务等相关状态
    initRightState() {
      this.jobState = ColumnUtils.getJobState(this.job)
      this.jobChangeState = this.cADetailHp.isCommittedAllowAddCost ? ColumnUtils.getJobChangeState(this.job) : ''
      console.log(this.job)
      if (!this.job.masterFlag) {
        Company.getCompanyById(this.job.customerId).then(company => {
          this.customerChineseName = company.chineseName
          this.customerEnglishName = company.englishName
        })
      } else {
        this.customerChineseName = ''
        this.customerEnglishName = ''
      }
    },
    handleTabClick() {
      if (!this.tabsRenderedSet.has(this.activeTabName)) {
        this.$nextTick(async() => {
          const loading = getLoading4Cxt(this)
          try {
            this.tabsRenderedSet.add(this.activeTabName)
            await this.$refs[this.activeTabName].onShow(this.job, true)
          } finally {
            loading && loading.close()
          }
        })
      }
    },
    handleCellFocused(e) {
      console.log(e)
      if (!e.column) return
      this.gridApi.clearFocusedCell()
      const { rowsToDisplay } = e.api.getModel()
      const curNode = rowsToDisplay[e.rowIndex]
      curNode.setSelected(true)
      this.gridApi.ensureIndexVisible(curNode.rowIndex)
      this.showDetail(curNode.data)
    },
    async showDetail(oneRowData, treeData) {
      this.toRenderTreeGrid(treeData, oneRowData.uuid)
      await this.cADetailHp.initCache()
      this.lob = oneRowData.lob
      this.masterFlag = oneRowData.masterFlag
      this.jobUuid = oneRowData.uuid
      this.loading = getLoading4Cxt(this)
      this.tabsRenderedSet.clear()
      await this.cADetailHp.getAndSetJobDetail().then(async res => {
        this.showContentArea = true
        // 因除海出外，其他业务无订舱页签，所以切换业务时，需做控制
        if ((this.activeTabName === 'tabVesselEq' && this.lob !== 'SE') || (this.activeTabName === 'tabSopState' && !this.showTabSopState)) {
          this.activeTabName = 'basic'
        }
        this.initRightState()
        await this.handleTabClick()
      }).catch(() => {
        this.$message.warning(this.$t('Message.FailedToGetDetails'))
      }).finally(() => {
        this.loading.close()
      })
    },
    toRenderTreeGrid(treeData, locationUuid) {
      this.gridOptions.api.deselectAll()
      this.gridApi.clearFocusedCell()
      // 更新左侧树
      if (treeData && treeData.length) {
        this.rowData = [...treeData]
      }
      this.$nextTick(() => {
        this.gridOptions.api.forEachNode(node => {
          if (node.data.uuid === locationUuid) {
            node.setSelected(true)
            this.gridApi.ensureIndexVisible(node.rowIndex)
          }
        })
      })
    },
    toBackList() {
      this.$emit('backList', this.viewSource)
    },
    async doPrintPROFIT(event) {
      if (event.action === 'print') {
        if (this.job && this.job.uuid) {
          // MessageDialog.confirm("打印利润分析表后, 本单业务将提交财务审核,不可再更改.是否继续？", "警告", null, onConfirmedPrintProfit);
          await this.$confirm(this.$t('Message.AfterPrintingTheProfitAnalysisStatement'), this.$t('common.tips.prompt'), { type: 'warning' })
          this.onConfirmedPrintProfit(event)
        }
      } else {
        calculateProfit(this.job.uuid, -1, true, this.cADetailHp.allSubmitFcl, false, this.$store.getters.currentOfficeId, '', this.location).then(res => {
          //   FlexGlobals.topLevelApplication.status = "";
          PrintTemplateManager.print(event.template, event.documentType, event.format, event.parameter, false)
        })
      }
      this.templateSelectorDialog.visible = false
    },
    onConfirmedPrintProfit(event) {
      calculateProfit(this.job.uuid, -1, true, this.cADetailHp.allSubmitFcl, false, this.$store.getters.currentOfficeId, '', this.location).then(res => {
        if (StimulSoftUtil.isOpenStiReport(event.template)) {
          StimulSoftUtil.stiReportPreview(event.template, this.job, event.parameter)
        } else {
          PrintTemplateManager.print(event.template, event.documentType, event.format, event.parameter, true)
        }
      }).catch(e => {
        this.$message.warning(this.$t('Message.PleaseEnterTheBoxSealNumber'))
      })
    },
    // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
    onPrintCallback(params) {
      if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
        this.prePrintCallback = params.prePrintCallback
        delete params.prePrintCallback
      } else {
        this.prePrintCallback = this.$refs[this.activeTabName].prePrintCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
        this.printedCallback = params.printedCallback
        delete params.printedCallback
      } else {
        this.printedCallback = this.$refs[this.activeTabName].printedCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
        this.v2CheckCallback = params.v2CheckCallback
        delete params.v2CheckCallback
      } else {
        this.v2CheckCallback = this.$refs[this.activeTabName].v2CheckCallback || null
      }
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.getRenderedNodes()
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        if (item.data.jobUuid === row.uuid || !item.data.uuid) {
          item.setSelected(true)
          this.gridApi.ensureIndexVisible(item.rowIndex)
          break
        }
      }
    }
  }
}
</script>

<style lang="scss">

  .finance-detail{

    .app-dropdown-menu {
      width: 50px;
    }
    .app-btn-cascader {
      border: none !important;
      border-radius: 0px !important;
    }
    .app-btn-cascader-pop {
      width: 100px;
      background: red;
    }
  }

</style>
